import React from 'react'

const SvgIconCheveronRight = (props) => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M9 18l6-6-6-6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgIconCheveronRight
